// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface PublicationVersionConflict
 */
export interface PublicationVersionConflict {
  /**
   *
   */
  version: number;
  /**
   *
   */
  createdAt?: Date | null;
  /**
   *
   */
  createdById?: string | null;
  /**
   *
   */
  createdByName?: string | null;
}

/**
 * Check if a given object implements the PublicationVersionConflict interface.
 */
export function instanceOfPublicationVersionConflict(
  value: object
): value is PublicationVersionConflict {
  if (!("version" in value) || value["version"] === undefined) return false;
  return true;
}

export function PublicationVersionConflictFromJSON(json: any): PublicationVersionConflict {
  return PublicationVersionConflictFromJSONTyped(json, false);
}

export function PublicationVersionConflictFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionConflict {
  if (json == null) {
    return json;
  }
  return {
    version: json["version"],
    createdAt:
      json["created_at"] === undefined
        ? undefined
        : json["created_at"] === null
        ? null
        : parseDateTime(json["created_at"]),
    createdById:
      json["created_by_id"] === undefined
        ? undefined
        : json["created_by_id"] === null
        ? null
        : json["created_by_id"],
    createdByName:
      json["created_by_name"] === undefined
        ? undefined
        : json["created_by_name"] === null
        ? null
        : json["created_by_name"],
  };
}

export function PublicationVersionConflictToJSON(json: any): PublicationVersionConflict {
  return PublicationVersionConflictToJSONTyped(json, false);
}

export function PublicationVersionConflictToJSONTyped(
  value?: PublicationVersionConflict | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    version: value["version"],
    created_at:
      value["createdAt"] == null ? value["createdAt"] : serializeDateTime(value["createdAt"]),
    created_by_id: value["createdById"],
    created_by_name: value["createdByName"],
  };
}
